import { styled } from '@mui/styles';
import React, { useState } from 'react';
import {
  AutocompleteArrayInput, Edit, SimpleForm, Toolbar, SaveButton, DeleteButton,
  TextInput, NumberInput, ReferenceArrayInput, SelectInput, ReferenceInput,
  useNotify, Confirm
} from 'react-admin';
import { axios as httpClient } from '../api';

// Deletes all Action logs of this turbine (Orbital > Advanced > Action logs),
// admins only (DELETE /actionLogs/:id). Separate from Save, with its own
// confirmation - it can't be undone.
const ClearActionLogs = ({ record }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const notify = useNotify();

  if (!record) return null;

  const handleClear = async () => {
    setConfirmOpen(false);
    setLoading(true);
    try {
      const { data } = await httpClient.delete(`/actionLogs/${record.id}`);
      notify(`Action logs cleared (${data.deleted} deleted)`);
    } catch (err) {
      notify((err.response && err.response.data && err.response.data.error) || err.message, { type: 'warning' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: '2rem', padding: '1rem', border: '1px solid #ddd', maxWidth: '32rem' }}>
      <h3>Action logs</h3>
      <p>Deletes every action log entry of this turbine (Advanced &gt; Action logs). Cannot be undone.</p>
      <button type="button" disabled={loading} onClick={() => setConfirmOpen(true)}>
        Clear action logs
      </button>
      <Confirm
        isOpen={confirmOpen}
        title="Clear action logs?"
        content={`Delete ALL action logs of "${record.name}"? This cannot be undone.`}
        onConfirm={handleClear}
        onClose={() => setConfirmOpen(false)}
      />
    </div>
  );
};

const WindTurbineTitle = ({ record }) => {
  return <span>Wind Turbine {record ? `"${record.name}"` : ''}</span>;
};

const StyledToolbar = styled(Toolbar)({
    display: 'flex',
    justifyContent: 'space-between',
});

const CustomToolbar = props => (
  <StyledToolbar {...props}>
      <SaveButton />
      {props?.permissions === "ADMIN" && <DeleteButton mutationMode="pessimistic" /> }
  </StyledToolbar>
);
export default (props) => (
  <Edit title={<WindTurbineTitle />} {...props} mutationMode="pessimistic">
    <SimpleForm toolbar={<CustomToolbar {...props} />}>
      <TextInput disabled source="id" />
      <TextInput source="name" />
      <TextInput
        source="identifier"
        label="Serial Number (Identifier)"
        helperText="Cod numeric simplu (ex. 0001, 0002, 00015...). Trebuie să fie identic cu username-ul MQTT configurat pe placă - dacă nu coincide exact, turbina nu va primi niciodată date."
      />

      <ReferenceArrayInput label="Users" source="userIds" reference="users" filterToQuery={q => ({})}>
        <AutocompleteArrayInput />
      </ReferenceArrayInput>

      <TextInput source="latitude" label="Latitude" />
      <TextInput source="longitude" label="Longitude" />

      {/* source must match the API's camelCase "maxPower" - it was "maxpower",
          so the form never found the stored value, always showed the 62
          default, and saving any other field re-sent 62 over the real one. */}
      <NumberInput source="maxPower" format={v => Math.round(v*100)/100} defaultValue={62} />

      <TextInput
        source="email"
        label="Email notificări erori"
        helperText="Adresa la care se trimit erorile turbinei, din pagina de informații (Orbital)."
      />

      <ReferenceInput label="Type" reference="turbineTypes" source="type.id">
        <SelectInput optionText="name"/>
      </ReferenceInput>

      <ReferenceInput label="Farm" reference="farms" source="farm.id">
        <SelectInput optionText="name"/>
      </ReferenceInput>

      {props?.permissions === "ADMIN" && <ClearActionLogs />}
    </SimpleForm>
  </Edit>
);
